import React from "react";
import { toast } from "react-toastify";
import "./StepSpecializations.css";

export const specializationsList = [
  "Anxiety",
  "Depression",
  "Bipolar Disorder",
  "Trauma & PTSD",
  "Grief & Loss",
  "OCD",
  "Panic Attacks",
  "Phobias",
  "ADHD",
  "Autism Spectrum",
  "Substance Use",
  "Eating Disorders",
  "Personality Disorders",
  "Anger Management",
  "Family Conflict",
  "Communication Issues",
  "Infidelity Recovery",
  "Life Transitions",
  "Career Stress",
  "Workplace Burnout",
  "Academic Stress",
  "Financial Stress",
  "Self-Esteem",
  "Confidence Building",
  "Emotional Regulation",
];

const TargetIcon = () => (
  <svg
    width="81"
    height="81"
    viewBox="0 0 81 81"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M65.6301 50.6689C63.4414 56.4303 59.4537 61.3327 54.2585 64.6485C49.0633 67.9644 42.9376 69.517 36.7902 69.076C30.6428 68.635 24.8014 66.2239 20.1328 62.2004C15.4641 58.177 12.2169 52.7556 10.8731 46.7407C9.52929 40.7258 10.1604 34.438 12.6728 28.8102C15.1853 23.1824 19.4451 18.5145 24.8203 15.4991C30.1955 12.4838 36.3995 11.2818 42.5119 12.0713C48.6243 12.8608 54.3193 15.5999 58.7518 19.8821"
      stroke="#27B99A"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M56.0487 47.3648C55.471 48.8229 54.7088 50.201 53.7807 51.4654C51.612 54.4276 48.6135 56.6802 45.1646 57.9383C41.7156 59.1965 37.971 59.4036 34.4043 58.5336C30.8376 57.6636 27.609 55.7555 25.1268 53.0506C22.6445 50.3457 21.0201 46.9654 20.4589 43.3373C19.8977 39.7092 20.425 35.9961 21.974 32.6677C23.523 29.3392 26.0243 26.5448 29.1615 24.6379C32.2986 22.731 35.9308 21.7971 39.5987 21.9544C43.2666 22.1118 46.8055 23.3532 49.7678 25.5218C50.1897 25.8323 50.5981 26.1563 50.9862 26.4938"
      stroke="#27B99A"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M45.6098 45.4849C44.6239 46.8313 43.2608 47.8551 41.6931 48.4269C40.1253 48.9986 38.4231 49.0926 36.8019 48.697C35.1807 48.3014 33.7132 47.4339 32.585 46.2042C31.4569 44.9746 30.7186 43.438 30.4638 41.7888C30.2089 40.1395 30.4488 38.4518 31.1531 36.9389C31.8574 35.426 32.9945 34.156 34.4207 33.2894C35.8468 32.4228 37.4979 31.9986 39.1651 32.0703C40.8324 32.1421 42.4409 32.7067 43.7873 33.6926"
      stroke="#27B99A"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M54.7728 36.8347L40.0376 40.2874"
      stroke="#27B99A"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M68.5699 33.6015L73.9227 36.9225C74.1816 37.0833 74.3871 37.3171 74.5132 37.5946C74.6393 37.872 74.6804 38.1806 74.6313 38.4813C74.5822 38.7821 74.4451 39.0616 74.2373 39.2845C74.0295 39.5074 73.7603 39.6638 73.4637 39.7339L63.2881 42.1166L54.7729 36.8348L60.0548 28.3196L70.2304 25.9369C70.5272 25.8666 70.8382 25.8861 71.1239 25.9929C71.4096 26.0997 71.6571 26.289 71.835 26.5367C72.0129 26.7844 72.1132 27.0794 72.1232 27.3842C72.1332 27.689 72.0523 27.9899 71.891 28.2488L68.5699 33.6015Z"
      stroke="#27B99A"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const StepSpecializations = ({
  data,
  onChange,
  onNext,
  onBack,
  onSave,
  loading = false,
  mode = "registration",
}) => {
  const selected = Array.isArray(data?.specializations)
    ? data.specializations
    : [];

  const toggleSpecialization = (spec) => {
    if (selected.includes(spec)) {
      onChange(
        "specializations",
        selected.filter((s) => s !== spec),
      );
    } else {
      onChange("specializations", [...selected, spec]);
    }
  };

  const handleNextClick = () => {
    if (selected.length === 0) {
      toast.error("Please select at least one specialization.");
      return;
    }
    onNext?.(data, () => {});
  };

  const handleSaveClick = () => {
    if (selected.length === 0) {
      toast.error("Please select at least one specialization.");
      return;
    }
    onSave?.({ specializations: selected });
  };

  return (
    <div className="step-specializations">
      <div className="step-specializations-icon">
        <TargetIcon />
      </div>

      <h2 className="step-specializations-title">Specializations</h2>

      <p className="step-specializations-desc">
        Select the areas you specialize in. This helps clients find the right
        fit more easily.
      </p>

      <div className="step-specializations-grid">
        {specializationsList.map((spec) => {
          const isSelected = selected.includes(spec);
          return (
            <button
              key={spec}
              type="button"
              className={`step-specializations-chip ${
                isSelected ? "selected" : ""
              }`}
              onClick={() => toggleSpecialization(spec)}
            >
              {spec}
            </button>
          );
        })}
      </div>

      {mode === "edit" ? (
        <div className="step-specializations-edit-actions">
          <button
            type="button"
            className="pp-btn-cancel"
            onClick={onBack}
            disabled={loading}
          >
            Cancel
          </button>
          <button
            type="button"
            className="pp-btn-save"
            onClick={handleSaveClick}
            disabled={loading}
          >
            {loading ? "Saving..." : "Save Changes"}
          </button>
        </div>
      ) : (
        <div className="step-specializations-next-wrap">
          <button
            type="button"
            onClick={handleNextClick}
            className="step-specializations-next-btn"
            disabled={loading}
          >
            <span className="step-specializations-next-inner">
              <span className="step-specializations-next-label">Next</span>
              <span className="step-specializations-next-icon">
                <svg
                  width="37"
                  height="37"
                  viewBox="0 0 37 37"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                >
                  <circle
                    cx="18.3673"
                    cy="18.3673"
                    r="17.8673"
                    fill="white"
                    fillOpacity="0.1"
                    stroke="white"
                  />
                  <path
                    d="M17.993 11.995L24.7402 18.7421L17.993 24.7396"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    opacity="0.5"
                    d="M13 13.7257L18.2478 18.8853L13 23.4716"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
            </span>
          </button>
        </div>
      )}
    </div>
  );
};

export default StepSpecializations;
